"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _usePagination = require("../use-pagination");

var _clsx = _interopRequireDefault(require("../utils/clsx"));

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _pagination = require("./pagination.styles");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const defaultProps = {
  preserveContent: false
};

const getItemAriaLabel = page => {
  if (!page) return;

  switch (page) {
    case _usePagination.DOTS:
      return 'dots element';

    case '<':
      return 'previous page button';

    case '>':
      return 'next page button';

    case 'first':
      return 'first page button';

    case 'last':
      return 'last page button';

    default:
      return `${page} item`;
  }
};

const preClass = 'nextui-pagination-item';

const PaginationItem = ({
  active,
  value,
  children,
  disabled,
  animated,
  bordered,
  onClick,
  onlyDots,
  preserveContent,
  ...props
}) => {
  const ariaLabel = (0, _react.useMemo)(() => active ? `${getItemAriaLabel(value)} active` : getItemAriaLabel(value), [value, active]);

  const clickHandler = event => {
    if (disabled) return;
    onClick && onClick(event);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_pagination.StyledPaginationItem, {
    className: (0, _clsx.default)(preClass, {
      [`${preClass}-active`]: active,
      [`${preClass}-animated`]: animated,
      [`${preClass}-disabled`]: disabled,
      [`${preClass}-bordered`]: bordered,
      [`${preClass}-only-dots`]: onlyDots,
      [`${preClass}-preserve-content`]: preserveContent
    }),
    animated: animated,
    active: active,
    disabled: disabled,
    bordered: bordered,
    onlyDots: onlyDots,
    preserveContent: preserveContent,
    onClick: clickHandler,
    "aria-label": ariaLabel,
    tabIndex: disabled ? -1 : 0,
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_pagination.StyledPaginationItemContent, {
      className: `${preClass}-content`,
      children: children
    })
  });
};

PaginationItem.toString = () => '.nextui-pagination-item';

var _default = (0, _withDefaults.default)(PaginationItem, defaultProps);

exports.default = _default;
module.exports = exports.default;